<template>
  <div class="addOrUpdate-block">
    <el-form
      class="detail-form-content"
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="80px">
      <el-row>
        <el-col :span="12">
          <el-form-item label="资质名称" prop="name">
            <el-input v-model="ruleForm.name" placeholder="资质名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="资质图片" prop="image">
            <file-upload
              tip="点击上传资质图片"
              action="file/upload"
              :limit="1"
              :multiple="false"
              :fileUrls="ruleForm.image?ruleForm.image:''"
              @change="imageUploadChange">
            </file-upload>
          </el-form-item>
        </el-col>
      </el-row>
      
      <el-form-item>
        <el-button type="primary" @click="onSubmit" icon="el-icon-check">提交</el-button>
        <el-button @click="back()" icon="el-icon-close">返回</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import fileUpload from "@/components/common/FileUpload";
export default {
  data() {
    return {
      id: '',
      type: '',
      ruleForm: {
        name: '',
        image: ''
      },
      rules: {
        name: [
          { required: true, message: '资质名称不能为空', trigger: 'blur' }
        ],
        image: [
          { required: true, message: '资质图片不能为空', trigger: 'blur' }
        ]
      }
    };
  },
  components: {
    fileUpload
  },
  methods: {
    init(id, type) {
      if (id) {
        this.id = id;
        this.type = "修改";
        this.$http({
          url: `qualification/info/${this.id}`,
          method: "get"
        }).then(({ data }) => {
          if (data && data.code === 0) {
            this.ruleForm = data.data;
            // 如果是编辑模式，确保图片URL有完整前缀用于显示
            if (this.ruleForm.image && !this.ruleForm.image.startsWith('http')) {
              this.ruleForm.image = 'https://ht.yiminkangjian.top/taoziyiyuan/' + this.ruleForm.image;
            }
          }
        });
      } else {
        this.id = '';
        this.type = "新增";
      }
    },
    // 图片上传
    imageUploadChange(fileUrls) {
      // 去掉URL前缀，只存储相对路径
      if (fileUrls && typeof fileUrls === 'string') {
        // 移除 https://ht.yiminkangjian.top/taoziyiyuan/ 前缀
        const prefix = 'https://ht.yiminkangjian.top/taoziyiyuan/';
        if (fileUrls.startsWith(prefix)) {
          this.ruleForm.image = fileUrls.substring(prefix.length);
        } else {
          this.ruleForm.image = fileUrls;
        }
      } else {
        this.ruleForm.image = fileUrls;
      }
    },
    // 返回
    back() {
      this.parent.showFlag = true;
      this.parent.addOrUpdateFlag = false;
      this.parent.getDataList();
    },
    // 提交
    onSubmit() {
      this.$refs["ruleForm"].validate(valid => {
        if (valid) {
          this.$http({
            url: `qualification/${!this.ruleForm.id ? "save" : "update"}`,
            method: "post",
            data: this.ruleForm
          }).then(({ data }) => {
            if (data && data.code === 0) {
              this.$message({
                message: "操作成功",
                type: "success",
                duration: 1500,
                onClose: () => {
                  // 先刷新数据列表，然后关闭页面
                  this.$parent.getDataList();
                  this.$parent.showFlag = true;
                  this.$parent.addOrUpdateFlag = false;
                }
              });
            } else {
              this.$message.error(data.msg);
            }
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.addOrUpdate-block {
  background: white;
  border-radius: 8px;
  padding: 24px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .detail-form-content {
    .el-form-item {
      margin-bottom: 24px;

      .el-form-item__label {
        font-weight: 500;
        color: #374151;
      }

      .el-input {
        .el-input__inner {
          border-radius: 6px;
          border: 1px solid #d1d5db;
          transition: all 0.2s ease;

          &:focus {
            border-color: #667eea;
            box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          }
        }
      }
    }

    .el-button {
      padding: 12px 24px;
      border-radius: 6px;
      font-weight: 500;
      transition: all 0.2s ease;

      &.el-button--primary {
        background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
        border: none;

        &:hover {
          transform: translateY(-1px);
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
        }
      }

      &:not(.el-button--primary) {
        background: #f8fafc;
        border: 1px solid #e2e8f0;
        color: #64748b;

        &:hover {
          background: #f1f5f9;
          border-color: #cbd5e1;
          color: #475569;
        }
      }
    }
  }
}

// 文件上传组件样式
:deep(.file-upload) {
  .upload-area {
    border: 2px dashed #d1d5db;
    border-radius: 8px;
    padding: 20px;
    text-align: center;
    transition: all 0.2s ease;

    &:hover {
      border-color: #667eea;
      background: #f8fafc;
    }

    .upload-icon {
      font-size: 24px;
      color: #9ca3af;
      margin-bottom: 8px;
    }

    .upload-text {
      color: #6b7280;
      font-size: 14px;
    }
  }

  .file-list {
    margin-top: 16px;

    .file-item {
      display: flex;
      align-items: center;
      padding: 8px 12px;
      background: #f8fafc;
      border-radius: 6px;
      margin-bottom: 8px;

      .file-name {
        flex: 1;
        color: #374151;
        font-size: 14px;
      }

      .file-actions {
        .el-button {
          padding: 4px 8px;
          font-size: 12px;
        }
      }
    }
  }
}
</style> 